import { render, staticRenderFns } from "./StockCorrections.vue?vue&type=template&id=279b7414&scoped=true"
import script from "./StockCorrections.vue?vue&type=script&lang=js"
export * from "./StockCorrections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b7414",
  null
  
)

export default component.exports